/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */
/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
/* eslint-disable import/no-mutable-exports */

import deprecatedProperty from '../../utilities/warning/deprecated-property';

let checkProps = function () {};

if (process.env.NODE_ENV !== 'production') {
	checkProps = function (COMPONENT, props) {
		deprecatedProperty(
			COMPONENT,
			props.skipToContentAssistiveText,
			'skipToContentAssistiveText',
			"assistiveText['skipToContent']"
		);
		deprecatedProperty(
			COMPONENT,
			props.skipToNavAssistiveText,
			'skipToNavAssistiveText',
			"assistiveText['skipToNav']"
		);
	};
}

export default checkProps;



// WEBPACK FOOTER //
// ./components/global-header/check-props.js